import React from "react"
import { Row } from "react-bootstrap"
import Container from "../../components/Layout/Container"
import Wrapper from "../../components/Layout/Wrapper"
import styles from "./GalleryErrorPage.module.css"
import { HomeCarousel } from "../HomePage/HomeCarousel"
import CustomError from "../../components/CustomError"

const GalleryErrorPage = ({ status, gallery, featuredGalleries }) => {
  const galleryName = gallery?.name
    ? `${gallery.name}`
    : "The gallery you are looking for"

  const getErrorMessage = (status) => {
    switch (status) {
      case 404:
        return (
          <>
            The gallery <b>{galleryName}</b> does not exist.
          </>
        )
      case 403:
        return (
          <>
            <b>{galleryName}</b> is not available. Check out these other
            galleries instead:
          </>
        )
      case 500:
      default:
        return "Something went wrong. Please try again later."
    }
  }

  return (
    <Wrapper>
      <Container>
        <Row
          className={`justify-content-center text-black fs-15px fs-mobile-14px ${
            featuredGalleries
              ? styles.galleryErrorPageExtended
              : styles.galleryErrorPage
          }`}>
          <CustomError title={getErrorMessage(status)} />
        </Row>
        {featuredGalleries && (
          <div>
            <HomeCarousel featuredGalleries={featuredGalleries} />
          </div>
        )}
      </Container>
    </Wrapper>
  )
}

export default GalleryErrorPage
